import { Stack, Text } from '@mantine/core';
import { AfaModal, AfaAnchor } from '../../ui';

interface InfoInteresseModalProps {
  opened: boolean;
  onClose: () => void;
}

export function InfoInteresseModal({ opened, onClose }: InfoInteresseModalProps) {
  return (
    <AfaModal
      opened={opened}
      onClose={onClose}
      title="Informació d'interès"
      size="lg"
      centered
    >
      <Stack gap="md" mt="md">
        <AfaAnchor href="#" size="md">
          Guia sobre Autoritzacions, inscripcions i altres comunicacions a l'AFA - Oficina Virtual
        </AfaAnchor>
        
        <AfaAnchor href="#" size="md">
          Actes sotmesos i formularis Comunicat núm. 1/2022-SF
        </AfaAnchor>
        
        <AfaAnchor href="#" size="md">
          Llistat de processos EB
        </AfaAnchor>

        <Stack>
          <Text size="md" fw={400}>
            Per a qualsevol incidència tècnica o relacionada amb els processos, si us plau, contacteu a{' '}
            <AfaAnchor href="mailto:reporting@afa.ad" size="md">
              reporting@afa.ad
            </AfaAnchor>
          </Text>
        </Stack>
      </Stack>
    </AfaModal>
  );
}
